import {logErrorWithSentry, logWarningWithSentry} from '../utils/sentry'

export const logger = {
  error: logErrorWithSentry,
  warn: logWarningWithSentry,
  log: console.log,
}
